export const CLIENT_FNT_REDACTED = "REDACTED";
export const CLIENT_FNT_COLUMN_DATE_FORMAT = "DD MMM YYYY";
export const CLIENT_FNT_FIELD_REBATE_ACCOUNT_ID = "rebateAccountID";
export const CLIENT_FNT_TABLE_FILTER_REPORT_START_DATE = "2024-01-01T00:00:00";
